import { defineMessages } from 'react-intl';

const messages = defineMessages({
  editShipToWarningTitle: {
    description: 'orderEpics.editShipToWarningTitle',
    defaultMessage: 'Warning',
    id: 'GG3/yu',
  },
});

export default messages;
